import React from 'react';
import { Button, CircularProgress, IconButton, Tooltip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SendIcon from '@mui/icons-material/Send';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from './AISuggestionCard.module.css';

/**
 * Card de sugestão de resposta da IA (modo copiloto).
 * A sugestão NUNCA é enviada automaticamente: a secretária decide entre
 * enviar como está, editar no campo de digitação, regenerar ou descartar.
 *
 * notes: observações internas da IA para a equipe (nunca vão ao paciente).
 * stale: chegou mensagem nova na conversa depois que a sugestão foi gerada.
 */
const AISuggestionCard = ({ loading, error, suggestion, notes, stale, onSendSuggestion, onEdit, onRegenerate, onDiscard }) => {
  if (!loading && !error && !suggestion) return null;

  const hasNotes = Array.isArray(notes) && notes.length > 0;

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <AutoAwesomeIcon fontSize="small" style={{ color: 'var(--color-blue-main, #5A80FB)' }} />
        <span className={styles.headerLabel}>Sugestão da IA</span>
        <Tooltip title="Descartar">
          <span>
            <IconButton size="small" onClick={onDiscard} disabled={loading}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </div>

      {loading ? (
        <div className={styles.loadingRow}>
          <CircularProgress size={16} />
          <span>Gerando sugestão de resposta...</span>
        </div>
      ) : error ? (
        <>
          <div className={styles.text}>{error}</div>
          <div className={styles.actions}>
            <Button size="small" variant="outlined" startIcon={<RefreshIcon />} onClick={onRegenerate}
              style={{ textTransform: 'none', borderRadius: '8px' }}>
              Tentar novamente
            </Button>
          </div>
        </>
      ) : (
        <>
          {stale && (
            <div className={styles.staleNotice}>
              <InfoOutlinedIcon fontSize="inherit" />
              <span>Chegou mensagem nova depois desta sugestão. Confira antes de enviar ou gere outra.</span>
            </div>
          )}

          <div className={styles.text}>{suggestion}</div>

          {hasNotes && (
            <div className={styles.notes}>
              <div className={styles.notesLabel}>Observações para a equipe (não vão para o paciente)</div>
              <ul className={styles.notesList}>
                {notes.map((note, index) => (
                  <li key={index}>{note}</li>
                ))}
              </ul>
            </div>
          )}

          <div className={styles.actions}>
            <Button size="small" variant="contained" startIcon={<SendIcon />} onClick={onSendSuggestion}
              style={{
                backgroundColor: 'var(--color-secondary, #ED3680)',
                color: '#fff',
                textTransform: 'none',
                borderRadius: '8px',
              }}>
              Enviar
            </Button>
            <Button size="small" variant="outlined" startIcon={<EditOutlinedIcon />} onClick={onEdit}
              style={{ textTransform: 'none', borderRadius: '8px' }}>
              Editar
            </Button>
            <Button size="small" variant="text" startIcon={<RefreshIcon />} onClick={onRegenerate}
              style={{ textTransform: 'none', borderRadius: '8px', color: 'var(--color-text-medium, #4A5568)' }}>
              Regenerar
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default AISuggestionCard;
